import axios from "axios";
import ACTIVE_ENV from "./env";
import { trimLeft } from "./utils";

console.log("ACTIVE_ENV: ", ACTIVE_ENV);
const axiosClient = axios.create({
    baseURL: ACTIVE_ENV["API_BASE_URL"],
})

/**
 * 
 * @param {string} path 
 * @param {any} data
 * @param {import("axios").AxiosRequestConfig} config 
 * @returns {import("axios").AxiosResponse}
 */
export function post(path, data, config) {
    return axiosClient.post(trimLeft(path, "/"), data, config);
}

/**
 * 
 * @param {string} path 
 * @param {import("axios").AxiosRequestConfig} config 
 * @returns {import("axios").AxiosResponse}
 */
export function get(path, config) {
    return axiosClient.get(trimLeft(path, "/"), config);
}

const httpInterface = {
    get,
    post,
}

export default httpInterface
